import React, { Component } from 'react';
import 'index.css';
import './Loader.scss';

import CircularProgress from '@material-ui/core/CircularProgress';

class Loader extends Component {
    render() {
        let itemClass=this.props.className;
        itemClass+=" loader";
        if (this.props.loading) {
            itemClass+=" show";
        }
        return (
            <div className={itemClass}>
                <CircularProgress size="100" />
            </div>
        );
    }
}
export default Loader;
